// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-text[data-v-ebe331b0]{color:#024668;font-size:20px}.header-text span[data-v-ebe331b0]{font-weight:bold}.btn-next[data-v-ebe331b0]{background-color:#00d1da;font-size:20px;border:none;padding:12px 0}.btn-next.disabled[data-v-ebe331b0]{color:#fff;background-color:#6c757d;border-color:#6c757d}.resent-text[data-v-ebe331b0]{color:red;text-align:center}.text-error[data-v-ebe331b0]{color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
